// WhyKangarooCorp.js
import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const WhyKangarooCorp = () => {
  const reasons = [
    'Structured and transparent processes',
    'Consultation led guidance',
    'Trusted academic and employer partnerships',
    'Clear communication at every stage',
    'Support beyond applications and interviews'
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
            Why Notapaths
          </h2>
        </motion.div>

        {/* Reasons List */}
        <div className="max-w-3xl mx-auto">
          <div className="space-y-4">
            {reasons.map((reason, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex items-start gap-4 bg-[#F5F8FA] p-4 rounded-lg hover:bg-white hover:shadow-md transition-all"
              >
                <CheckCircle2 size={18} className="text-gray-700 flex-shrink-0 mt-1" />
                <p className="text-base text-gray-700 font-light">
                  {reason}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyKangarooCorp;
